import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-produit-detail-modal',
  templateUrl: './produit-detail-modal.component.html',
  styleUrls: ['./produit-detail-modal.component.scss']
})
export class ProduitDetailModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
